/**
 * Vibrates the device for `durationMs` when the Vibration API exists (absent on iOS). Never throws:
 * some browsers reject the call outside a user gesture.
 */
const vibrateDevice = (durationMs: number): void => {
	try {
		if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') {
			return;
		}

		navigator.vibrate(durationMs);
	} catch {
		// Haptic feedback is optional.
	}
};

export default vibrateDevice;
